import React from 'react';

const Portfolio = () => {
    return (
        <React.Fragment>
            <section className="pt-page pt-page-3" data-id="portfolio">
                <div className="section-title-block">
                    <h2 className="section-title">Portfolio</h2>
                    <h5 className="section-description">Independent Work</h5>
                </div>
                {/* Portfolio Content */}
                <div className="portfolio-content">
                    {/* Portfolio filter */}
                    <ul id="portfolio_filters" className="portfolio-filters">
                        <li className="active">
                            <a href="/#" className="filter btn btn-sm btn-link active"
                                data-group="all"
                            >
                                All
                            </a>
                        </li>
                        <li>
                            <a href="/#"
                                className="filter btn btn-sm btn-link"
                                data-group="ml"
                            >
                                Machine Learning
                            </a>
                        </li>
                        <li>
                            <a href="/#" className="filter btn btn-sm btn-link" data-group="wp">
                                Web Programming
                            </a>
                        </li>
                        <li>
                            <a href="/#" className="filter btn btn-sm btn-link" data-group="algo">
                                Algorithm
                            </a>
                        </li>
                        <li>
                            <a href="/#" className="filter btn btn-sm btn-link" data-group="da">
                                Data Analysis
                            </a>
                        </li>
                    </ul>
                    {/* End of Portfolio filter */}
                    {/* Portfolio Grid */}
                    <div
                        id="portfolio_grid"
                        className="portfolio-grid portfolio-masonry masonry-grid-3"
                    >
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "ml"]'>
                            <h3 className="text-center">Patient No Show</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/patient-no-show.html" data-href="patient-no-show.html">
                                <img src="images/portfolio/no-show.jpg" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Patient No Show Predictive Modeling</h5>
                                    <small>Machine Learning</small>
                                    <i className="fa fa-line-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">Amazon S3 Multipart Parallel Upload</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/s3-multipart-parallel-upload.html" data-href="s3-multipart-parallel-upload.html">
                                <img src="images/portfolio/django-s3-file-upload.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Amazon S3 Multipart Parallel Upload</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">GraphQL API Client</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/graphql-api-client.html" data-href="graphql-api-client.html">
                                <img src="images/portfolio/graphql-api-client.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">GraphQL API Client</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">GraphQL APIs in Django</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/graphql-api-django.html" data-href="graphql-api-django.html">
                                <img src="images/portfolio/graphql-api-django.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">GraphQL APIs in Django</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "ml"]'>
                            <h3 className="text-center">Social Circles Discovery</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/social-circles-discovery.html" data-href="social-circles-discovery.html">
                                <img src="images/portfolio/sna.jpg" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Social Circles Discovery</h5>
                                    <small>Machine Learning</small>
                                    <i className="fa fa-line-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">Data Exploration System</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/data-exploration-system.html" data-href="data-exploration-system.html">
                                <img src="images/portfolio/des.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Data Exploration System</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">GitHub Repos Visualization</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/github-repos-viz.html" data-href="github-repos-viz.html">
                                <img src="images/portfolio/grv.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">GitHub Repos Visualization</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]' >
                            <h3 className="text-center">Graph Analysis</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/graph-analysis.html" data-href="graph-analysis.html">
                                <img src="images/portfolio/ga.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Graph Analysis</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "ml"]'>
                            <h3 className="text-center">Multi-label Classification</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/multi-label-classification.html" data-href="multi-label-classification.html">
                                <img src="images/portfolio/class-label-distribution.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Multi-label Classification</h5>
                                    <small>Machine Learning</small>
                                    <i className="fa fa-line-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">HRMS</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/human-resource-management-system.html" data-href="human-resource-management-system.html">
                                <img src="images/portfolio/hrms.PNG" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Human Resource Management System</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">Cactus Rest Client</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/cactus-rest-client.html" data-href="cactus-rest-client.html">
                                <img src="images/portfolio/crc.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Cactus Rest Client</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">Stocks Data Visualization</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/stocks-data-visualization.html" data-href="stocks-data-visualization.html">
                                <img src="images/portfolio/sdv.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Stocks Data Visualization</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "algo"]'>
                            <h3 className="text-center">Sparse Vector Matrix Mul</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/sparse-matrix-vector-mul.html" data-href="sparse-matrix-vector-mul.html">
                                <img src="images/portfolio/spvm.jpg" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Sparse Vector Matrix Multiplication</h5>
                                    <small>Algorithm</small>
                                    <i className="fa fa-codepen" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">NOAA Storm Database Analysis</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/noaa-storm-dba.html" data-href="noaa-storm-dba.html">
                                <img src="images/portfolio/noaa.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">NOAA Storm Database Analysis</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item  */}
                        <figure className="item" data-groups='["all", "wp"]'>
                            <h3 className="text-center">SOAP Request Builder</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/soap-request-builder.html" data-href="soap-request-builder.html">
                                <img src="images/portfolio/srb.PNG" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">SOAP Request Builder</h5>
                                    <small>Web Programming</small>
                                    <i className="fa fa-code" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item  */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">NEI PM2.5 Data Analysis</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/nei-pm2.5-da.html" data-href="nei-pm2.5-da.html">
                                <img src="images/portfolio/nei.png" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">NEI PM2.5 Data Analysis</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "algo"]'>
                            <h3 className="text-center">Bellman Ford SSSP</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/bellman-ford-sssp.html" data-href="bellman-ford-sssp.html">
                                <img src="images/portfolio/bf.jpg" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Bellman Ford SSSP</h5>
                                    <small>Algorithm</small>
                                    <i className="fa fa-codepen" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">Human Activity Recognition</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/human-activity-recognition.html" data-href="human-activity-recognition.html">
                                <img src="images/portfolio/har.PNG" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Human Activity Recognition</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">Occupancy Detection Analysis</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/occupancy-detection-analysis.html" data-href="occupancy-detection-analysis.html">
                                <img src="images/portfolio/oda.PNG" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Occupancy Detection Analysis</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                        {/* /Portfolio Item */}
                        <figure className="item" data-groups='["all", "da"]'>
                            <h3 className="text-center">Death Rate Predictors Analysis</h3>
                            <a className="ajax-page-load" href="index.html#portfolio/death-rate-predictors-analysis.html" data-href="death-rate-predictors-analysis.html">
                                <img src="images/portfolio/regression.jpg" alt="" style={{ border: "3px solid #555" }} />
                                <div>
                                    <h5 className="name">Death Rate Predictors Analysis</h5>
                                    <small>Data Analysis</small>
                                    <i className="fa fa-bar-chart" />
                                </div>
                            </a>
                        </figure>
                        {/* /Portfolio Item */}
                    </div>
                    {/* /Portfolio Grid */}
                </div>
                {/* /Portfolio Content */}
            </section>
        </React.Fragment>
    );
};

export default Portfolio;